import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AdminModeProvider } from "@/context/AdminModeContext";
import PublicShowcase from "@/pages/PublicShowcase";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import ArtistSubmit from "@/pages/ArtistSubmit";
import ShareRedirect from "@/pages/ShareRedirect";
import AuthCallback from "@/pages/AuthCallback";
import NowPlayingBar from "@/components/NowPlayingBar";
import { Toaster } from "@/components/ui/sonner";

// Detect OAuth return (session_id in URL fragment) BEFORE normal routes render,
// so any protected routes don't try to check /auth/me first and 401.
function AppRouter() {
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<PublicShowcase />} />
      <Route path="/track/:rank" element={<PublicShowcase />} />
      <Route path="/track/:rank/:slug" element={<PublicShowcase />} />
      <Route path="/s/:code" element={<ShareRedirect />} />
      <Route path="/submit" element={<ArtistSubmit />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="*" element={<PublicShowcase />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <PlayerProvider>
              <AdminModeProvider>
                <AppRouter />
                <NowPlayingBar />
                <Toaster theme="dark" position="top-right" />
              </AdminModeProvider>
            </PlayerProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
